module.exports = __webpack_public_path__ + "img/Weapon_86.6cd6a2e2.png";